export default {
  nav_home: 'Início',
  nav_guides: 'Guias',
  nav_categories: 'Categorias',
  nav_shopping_guide: 'Guia de Compras',
  nav_safety: 'Segurança',
  nav_faq: 'FAQ',
  nav_about: 'Sobre',
  hero_eyebrow: 'CSSBuy Spreadsheet • Guias • Produtos • Dicas',
  hero_h1: 'CSSBuy Spreadsheet — Encontre Produtos, Vendedores e Guias em Um Só Lugar',
  hero_desc: 'Encontre e organize recursos úteis do CSSBuy com mais facilidade. Explore CSSBuy spreadsheets, produtos, vendedores, guias de QC, informações de envio, warehouse, cupons e dicas práticas para pesquisar melhor e tomar decisões mais informadas.',
  hero_cta_primary: 'Explorar CSSBuy Spreadsheet',
  hero_cta_secondary: 'Ver Guias CSSBuy',
  hero_search_placeholder: 'Pesquise por produto, categoria ou CSSBuy Spreadsheet...',
  trust_recursos: 'Recursos organizados',
  trust_atualizado: 'Conteúdo atualizado',
  trust_guides: 'Guias práticos',
  trust_seguranca: 'Foco em segurança',
  categories_h2: 'Categorias de Produtos',
  categories_desc: 'Navegue pelas categorias mais populares e encontre o que você procura.',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  cta_buy_it_now: 'Buy It Now',
  cta_visit_main: 'Visitar Site Principal',
  articles_h2: 'Guias e Artigos CSSBuy',
  articles_desc: 'Leia nossos guias completos para tomar decisões mais informadas.',
  article_read_guide: 'Ler Guia',
  footer_resources: 'Recursos',
  footer_categories: 'Categorias',
  footer_legal: 'Legal',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_disclaimer: 'Aviso Legal',
  footer_disclaimer_text: 'Este é um site independente de informações e recursos. Não somos oficialmente afiliados, patrocinados ou endossados pela CSSBuy, salvo indicação expressa.',
  footer_copyright: '© 2026 cssbuybr.living — Todos os direitos reservados.',
  review_h2: 'CSSBuy Review: O Que Você Precisa Saber Antes de Comprar',
  review_desc: 'Entenda como funcionam produtos, vendedores, warehouse, controle de qualidade e envio antes de tomar uma decisão. Nosso guia CSSBuy Review reúne informações práticas para ajudar você a avaliar o serviço de forma mais informada.',
  review_cta: 'Ler CSSBuy Review',
  shipping_h2: 'CSSBuy Shipping Cost: Entenda os Custos de Envio',
  shipping_desc: 'O custo de envio pode variar conforme peso, volume, destino e método escolhido. Consulte nosso guia para entender os principais fatores que influenciam o preço antes de finalizar sua compra.',
  shipping_cta: 'Ver CSSBuy Shipping Cost',
  coupon_h2: 'CSSBuy Coupon & Discount Code',
  coupon_desc: 'Consulte nosso guia de CSSBuy Coupon e CSSBuy Discount Code para entender onde procurar promoções, como verificar condições e como evitar códigos desatualizados ou suspeitos.',
  coupon_cta: 'Ver Cupons e Descontos',
  how_it_works_h2: 'Como Usar um CSSBuy Spreadsheet',
  how_step_1: 'Escolha uma categoria',
  how_step_2: 'Encontre um produto ou recurso',
  how_step_3: 'Verifique vendedor e informações',
  how_step_4: 'Consulte QC quando disponível',
  how_step_5: 'Analise envio e custos',
  how_step_6: 'Tome sua decisão',
  how_cta: 'Começar pelo CSSBuy Spreadsheet',
  comparison_h2: 'CSSBuy Spreadsheet vs. Pesquisa Manual',
  comparison_criterio: 'Critério',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_manual: 'Pesquisa Manual',
  comparison_organizacao: 'Organização',
  comparison_alta: 'Alta',
  comparison_variavel: 'Variável',
  comparison_descoberta: 'Descoberta',
  comparison_simples: 'Mais simples',
  comparison_demorada: 'Mais demorada',
  comparison_categorias: 'Categorias',
  comparison_estruturadas: 'Estruturadas',
  comparison_dispersas: 'Dispersas',
  comparison_pesquisa: 'Pesquisa',
  comparison_centralizada: 'Centralizada',
  comparison_diversas: 'Diversas fontes',
  comparison_guias: 'Guias',
  comparison_integrados: 'Integrados',
  comparison_separados: 'Separados',
  final_cta_h2: 'Encontre Seu Próximo CSSBuy Spreadsheet',
  final_cta_desc: 'Explore categorias, guias, comparações, informações de envio, QC e recursos para tornar sua pesquisa mais simples.',
  final_cta_primary: 'Explorar CSSBuy Spreadsheet',
  final_cta_secondary: 'Visitar Site Principal',
  breadcrumb_home: 'Início',
  article_updated: 'Atualizado',
  article_reading_time: 'min de leitura',
  related_articles: 'Artigos Relacionados',
  toc_title: 'Conteúdo',
  safety_note: 'Nota de Segurança',
  safety_note_text: 'Ao comprar internacionalmente, segurança deve vir antes da pressa. Aprenda como verificar links, produtos, vendedores, pagamentos, QC e informações de envio antes de tomar uma decisão.',
};